import { createSlice } from '@reduxjs/toolkit';
import { submitPopupNotification } from './Utils/PopupNotificationUtils';

const initialState = {
	image: '',
	url: '',
	target_page: '',
	is_show: "",
	isUpdate: false,
	id: '',
	isLoading: false,
};

const addPopupNotification = createSlice(
	{
		name: 'addPopupNotification',
		initialState: initialState,
		reducers: {
			setField: (state, action) => {
				const { field, value } = action.payload;
				state[field] = value;
			},
			resetState: (state) => {
				return initialState;
			},
		},
		extraReducers: (builder) => {
			builder
				.addCase(submitPopupNotification.pending, (state) => {
					// Handle loading state
					state.isLoading = true;
				})
				.addCase(submitPopupNotification.fulfilled, (state, action) => {
					// Handle success state
					state.isLoading = false;
					console.log('Sukses:', action.payload);
				})
				.addCase(submitPopupNotification.rejected, (state, action) => {
					// Handle error state
					state.isLoading = false;
					console.log(action.error.message, "error action")
				});
		}
	}
);


export const { setField, resetState } = addPopupNotification.actions;

export default addPopupNotification.reducer;